<template>
	<div id="wrap" v-loading="loading">
		<!-- <div class="flex flex-start" style="margin-bottom:20px;">
      <el-button type="primary">我管理的项目</el-button>
      <el-button type="primary">我参与的项目</el-button>
    </div> -->
		<div class="flex flex-start flex-wrap">
			<div>
				<el-form :inline="true">
					<el-form-item label="项目名称：">
						<el-input
							placeholder="请输入"
							v-model="queryParam.projectName"
						></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div>
				<el-form :inline="true">
					<el-form-item label="类型：">
						<el-select v-model="queryParam.projectType">
							<el-option
								v-for="item in projectTypes"
								:key="item.value"
								:label="item.label"
								:value="item.value"
							></el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</div>
			<div>
				<el-form :inline="true">
					<el-form-item label="申报区间：">
						<el-date-picker
							v-model="dateRange"
							type="daterange"
							value-format="yyyy-MM-dd"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
						>
						</el-date-picker>
					</el-form-item>
				</el-form>
			</div>
			<div>
				<el-button type="primary" @click="search">查询</el-button>
			</div>
		</div>

		<div class="flex flex-justify">
			<el-button type="primary" @click="toAdd"> 立项</el-button>
		</div>
		<el-table
			class="table"
			:data="tableData"
			:header-cell-style="{ background: '#F5F7FA' }"
			stripe
			:row-class-name="tableRowClassName"
		>
			<el-table-column label="项目编号" prop="projectNumber"> </el-table-column>
			<el-table-column prop="projectName" label="项目名称"> </el-table-column>
			<el-table-column
				prop="projectType"
				label="类型"
				:formatter="formatProjectType"
				show-overflow-tooltip
			></el-table-column>
			<el-table-column
				label="研发周期"
				prop="dateRange"
				:show-overflow-tooltip="true"
				:formatter="formatDateRange"
			></el-table-column>
			<!-- <el-table-column
        label="人员"
        width="120"
        prop="personalNumber"
      ></el-table-column> -->
			<el-table-column
				label="创建时间"
				width=""
				prop="createTime"
			></el-table-column>
			<el-table-column
				label="创建人"
				width=""
				prop="createUserId"
			></el-table-column>
			<el-table-column label="操作" width="200">
				<template slot-scope="scope">
					<el-button
						type="text"
						size="small"
						class="green"
						@click="edit(scope.row.id)"
						>编辑</el-button
					>
					<el-button
						type="text"
						size="small"
						class="red"
						@click="deleteProject(scope.row.id)"
						>删除</el-button
					>
					<el-button
						type="text"
						size="small"
						class="blue"
						v-if="scope.row.whetherRdProject == 1"
						@click="toNo(scope.row.id)"
						>转非研发项目</el-button
					>
				</template>
			</el-table-column>
		</el-table>
		<div class="flex flex-end">
			<el-pagination
				class="pagination"
				background
				layout="prev, pager, next,total"
				:total="total"
				v-show="total > 0"
				:current-page.sync="queryParam.pageNum"
				:page-size.sync="queryParam.pageSize"
				@current-change="search"
			>
			</el-pagination>
		</div>
	</div>
</template>

<script>
import { queryProject, changeProjectType, deleteProject } from "./index";
// import Template from "@/components/template";
export default {
	// components: {Template},
	data() {
		return {
			loading: false,
			total: 0,
			dateRange: [],
			ruleForm: {
				region: ""
			},
			queryParam: {
				pageNum: 1,
				pageSize: 10
			},
			tableData: [],
			value: "",
			options: [
				{
					value: "选项1",
					label: "选项1"
				},
				{
					value: "选项2",
					label: "选项2"
				}
			],
			projectTypes: [
				{ label: "全部", value: null },
				{ label: "自主研发", value: 1 },
				{ label: "委托研发", value: 2 },
				{ label: "合作研发", value: 3 },
				{ label: "集中研发", value: 4 }
			]
		};
	},
	created() {
		this.search();
	},
	methods: {
		toAdd() {
			sessionStorage.setItem("zt_jjkc_project_id", "");
			this.$router.push("/centerform/expenditurePersonnel");
		},
		edit(id) {
			sessionStorage.setItem("zt_jjkc_project_id", id);
			this.$router.push("/centerform/expenditurePersonnel");
		},
		formatDateRange(row, column) {
			return row.startTime + "至" + row.endTime;
		},
		formatProjectType(row, column) {
			// console.log(row)
			if (row.projectType == 1) {
				return "自主研发";
			}
			if (row.projectType == 2) {
				return "委托研发";
			}
			if (row.projectType == 3) {
				return "合作研发";
			}
			if (row.projectType == 4) {
				return "集中研发";
			}
		},
		tableRowClassName({ row, rowIndex }) {
			if ((rowIndex + 1) % 2 === 0) {
				return "background:#fff";
			} else {
				return "background:#F5F7FA";
			}
		},
		search() {
			this.loading = true;
			if (this.dateRange && this.dateRange.length > 0) {
				this.queryParam.startTime = this.dateRange[0];
				this.queryParam.endTime = this.dateRange[1];
			} else {
				this.queryParam.startTime = "";
				this.queryParam.endTime = "";
			}
			queryProject(this.queryParam).then(res => {
				this.tableData = res.data.records;
				this.total = res.data.total;
				this.queryParam.pageNum = res.data.current;
				this.queryParam.pageSize = res.data.size;
				this.loading = false;
			});
		},
		toNo(id) {
			this.loading = true;
			changeProjectType(id).then(res => {
				if (res.code == "00000") {
					this.loading = false;
					this.msgSuccess("操作成功");
					this.search();
				}
			});
		},
		deleteProject(id) {
			this.$confirm("是否确认删除项目", "警告", { type: "warning" }).then(
				ok => {
					if (ok) {
						this.loading = true;
						deleteProject(id).then(res => {
							this.msgSuccess("删除成功");
							this.loading = false;
							this.search();
						});
					}
				}
			);
		}
	}
};
</script>
<style scoped>
</style>
